module.exports = __webpack_public_path__ + "img/727-eef508.png";